import {
    SET_CAR_MAKE_VALUE,
    SET_CAR_MODEL_VALUE,
    SET_YEAR_OF_MANUFACTURE_VALUE,
    SET_COVER_START_DATE_VALUE,
    SET_IS_CAR_VALUED_VALUE,
    SET_CAR_VALUER_VALUE,
    SET_CAR_USE_VALUE,
    SET_VALUATION_VALUE,
    SET_HAS_ALARM_VALUE,
    SET_SHARE_EMAIL_VALUE,
    SET_EXCESS_PROTECTOR_VALUE,
    SET_UNCOMMON_RISK_VALUE,
    SET_IS_RARE_MODEL_VALUE,
    SET_OTHER_VALUER_VALUE,
    SET_VEHICLE_TYPE_VALUE,
    SET_FULL_NAME_VALUE,
    SET_OUTSIDE_EA_VALUE,
    SET_TRACKING_SYSTEM_VALUE,
    setCarMakeValid,
    setCarModelValid,
    setYearOfManufactureValid,
    setCoverStartDateValid,
    setIsCarValuedValid,
    setCarValuerValid,
    setCarUseValid,
    setHasAlarmValid,
    setValuationValid,
    setExcessProtectorValid,
    setUncommonRiskValid,
    setShareEmailValid,
    setIsRareModelValid,
    setOtherValuerValid,
    setVehicleTypeValid,
    setFullNameValid,
    setOutsideEaValid,
    setTrackingSystemValid,
} from '../../../actions/naMotorInsurance/quote';
import {
    validateYearOfManufacture,
    validateSelection,
    validateNumber,
    validateDate,
    validateEmail,
    validateName,
    validateSingleSelection,
} from '@om/validation';
import { validationIsEqual } from '../status';

let prevValidationAction = null;

export const quoteFormValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        let today = new Date();
        let validTodayDate = today.toLocaleDateString('en-NG').split('/').join('/');
        switch (action.type) {
            case SET_FULL_NAME_VALUE:
                error = validateName(action.value, {
                    min: 4,
                    subject: 'Full Name',
                });
                return setFullNameValid(error);

            case SET_CAR_MAKE_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Car make' });
                return setCarMakeValid(error);
            case SET_CAR_MODEL_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Car model' });
                return setCarModelValid(error);
            case SET_YEAR_OF_MANUFACTURE_VALUE:
                error = validateYearOfManufacture(action.value, {
                    subject: 'Year of manufacture',
                });
                return setYearOfManufactureValid(error);
            case SET_COVER_START_DATE_VALUE:
                error = validateDate(action.value, { required: true, min: validTodayDate });
                return setCoverStartDateValid(error);
            case SET_IS_CAR_VALUED_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Is car valued' });
                return setIsCarValuedValid(error);
            case SET_CAR_VALUER_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Car valuer' });
                return setCarValuerValid(error);
            case SET_CAR_USE_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Car use' });
                return setCarUseValid(error);
            case SET_HAS_ALARM_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Has alarm' });
                return setHasAlarmValid(error);
            case SET_TRACKING_SYSTEM_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Tracking system' });
                return setTrackingSystemValid(error);
            case SET_EXCESS_PROTECTOR_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Excess protector' });
                return setExcessProtectorValid(error);
            case SET_UNCOMMON_RISK_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Uncommon risk' });
                return setUncommonRiskValid(error);
            case SET_VALUATION_VALUE:
                error = validateNumber(action.value, {
                    required: true,
                    min: 1,
                    subject: 'Valuation',
                });
                return setValuationValid(error);
            case SET_SHARE_EMAIL_VALUE:
                error = validateEmail(action.value, { min: 1, subject: 'Share email' });
                return setShareEmailValid(error);
            case SET_IS_RARE_MODEL_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Is car rare' });
                return setIsRareModelValid(error);

            case SET_OUTSIDE_EA_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Outisde EA',
                });
                return setOutsideEaValid(error);

            case SET_OTHER_VALUER_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Other valuer' });
                return setOtherValuerValid(error);

            case SET_VEHICLE_TYPE_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Vehicle type' });
                return setVehicleTypeValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
